module.exports = __webpack_public_path__ + "img/repguide-wartung-oel.2bb09f87.jpg";